//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CourseSearchHero',
  props: {
    backgroundUrl: {
      type: String,
      default: '',
    },
    header: String,
    subheader: String,
    courseCount: String,
    pageName: String,
    descriptiveParagraph: String,
    customerQuote: String,
    customerName: String,
    url: String,
  },
};
